import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Modal from '@atlaskit/modal-dialog';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { ContextualAnalyticsData, MODAL } from '@atlassian/jira-product-analytics-bridge';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import Body from './body/index.tsx';
import Header from './header/index.tsx';

export type Props = {
	issueIds: IssueId[];
	hasPermissionForAllIssues: boolean;
	deploymentDisplayName: string;
	deploymentUrl: string;
	onClose: () => void;
};

const DeploymentDetailsModal = ({
	issueIds,
	deploymentDisplayName,
	deploymentUrl,
	hasPermissionForAllIssues,
	onClose,
}: Props) => (
	<ContextualAnalyticsData sourceType={MODAL} sourceName="deploymentNavigator">
		<ShortcutScope>
			<Modal width={gridSize * 116} height={gridSize * 67} autoFocus={false} onClose={onClose}>
				<Header onClose={onClose} />
				<Body
					issueIds={issueIds}
					deploymentUrl={deploymentUrl}
					deploymentDisplayName={deploymentDisplayName}
					hasPermissionForAllIssues={hasPermissionForAllIssues}
				/>
			</Modal>
		</ShortcutScope>
	</ContextualAnalyticsData>
);

export default DeploymentDetailsModal;
